import Vue from 'vue'
import Vuex from 'vuex'
import localStorage from '../utils/localStorage.js'
import createPersistedState from "vuex-persistedstate";
import {Profile,getSetting} from '@/api/index';
import dayjs from 'dayjs';
import design from './modules/design'
import scoket from './modules/scoket'
import { auth } from '@/utils/firebase'

Vue.use(Vuex)

export default new Vuex.Store({
	// strict: process.env.NODE_ENV !== 'production',
	state: {
		//isLogin: localStorage.get('ACCESS_TOKEN') ? true : false,
		userInfo: JSON.parse(localStorage.get('USER_INFO')),
		token: localStorage.get('ACCESS_TOKEN'),
		aliyun_oss:null,
		// Header判断是否登录使用
		is_login: false,
		setting: null,
		loginType:''
	},
	getters: {
		// 路由，页面中实时判断是否登录过期
		isLoginDynamic: (state) => () => {
			return !!(state.token)
		},
		isSettingLoad: (state) => () => {
			return !!state.setting
		}
	},
	mutations: {
		login(state, provider) {
			state.token = provider.token;
			state.is_login = true
			localStorage.set('ACCESS_TOKEN',provider.token)
			localStorage.set('expired_time',provider.time)
		},
		loginType(state, provider) {
			state.loginType = provider;
		},
		logout(state) {
			// state.loginInfo = {};
			state.userInfo = {};
			state.token = null
			state.is_login = false
			localStorage.remove('ACCESS_TOKEN')
			localStorage.remove('USER_INFO')
			if(state.loginType == 'google' || state.loginType == 'apple'){
				auth.signOut().then(() => {
					console.log('登出成功')
				})
				.catch(error => {
					console.error('登出失败:', error)
				})
			}
			
		},
		setUserInfo(state, provider) {
			state.userInfo = provider;
			localStorage.set('USER_INFO',provider)
		},
		setAliYunOSS(state, provider) {
			state.aliyun_oss = provider;
		},
		update_login_state(state, bool) {
			state.is_login = bool
		},
		updateSetting(state, setting) {
			state.setting = setting
			console.error(state)
		},
		clearLoginState(state){
			state.is_login = false;
			state.userInfo = {};
			state.token = null;
			localStorage.remove('expired_time');
			localStorage.remove('ACCESS_TOKEN')
			localStorage.remove('USER_INFO')
		}
	},
	actions: {
		async getSetting(context){
			const {data} = await getSetting();
			context.commit('updateSetting',data);
		},
		async getUser(context){
			const {data} = await Profile();
			context.commit('setUserInfo',data);
		},
		checkExpiredTime(context){
			const expired_time = localStorage.get('expired_time');
			const now = dayjs();
			const expired = dayjs(parseInt(expired_time)*1000);
			if(now.isAfter(expired) || !expired_time || expired_time === 'undefined'){
				console.log('token已过期');
				context.commit('clearLoginState');
			}
		}
	},
	modules: {
		design,
		scoket
	},
	plugins: [createPersistedState()],
})
